<template>
  <div>
    <div class="d-flex flex-column">
      <span class="combo-label">Compre e Ganhe</span>
      <span class="combo-name">{{ isGroup ? 'Voucher Digital com Grupo de Produtos' : 'Voucher Digital' }}</span>
    </div>
    <offer-sale-line :line-items="maxItem">
      <user-consumption :maximum-per-client="combo.trigger_rules.maximum_per_client" :user-sale-consumption-amount="combo.userSaleConsumptionAmount" />
    </offer-sale-line>

    <div class="d-flex flex-row align-center my-2" style="gap: 8px">
      <span class="trigger-target-label">Produtos gatilho ({{ triggerProductsAmount }})</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <industry-combo-sale-trigger
      v-for="offerSale in combo.trigger_products"
      :key="offerSale.sku"
      class="my-2"
      style="flex: 1"
      :offerSale="offerSale"
      :trigger-amount="combo.trigger_rules.trigger_amount"
    />

    <div class="d-flex flex-row align-center my-4" style="gap: 8px">
      <span class="trigger-target-label">Voucher</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <div class="voucher-container">
      <offer-sale-line :line-items="voucherItems"></offer-sale-line>
    </div>
  </div>
</template>

<script>
import UserConsumption from './UserConsumption.vue'
import IndustryComboSaleTrigger from './IndustryComboSaleTrigger.vue'
import OfferSaleLine from './OfferSaleLine.vue'

export default {
  name: 'DynamicRuleOfferSaleBase',
  components: {
    UserConsumption,
    IndustryComboSaleTrigger,
    OfferSaleLine,
  },
  props: {
    combo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isGroup() {
      return this.combo.trigger_products[0].group_id
    },
    userSaleConsumptionAmount() {
      return this.combo.trigger_products.reduce((acc, offerSale) => acc + offerSale.user_sale_consumption_amount, 0)
    },
    triggerProductsAmount() {
      return this.combo.trigger_products.length
    },
    maxItem() {
      return [
        {
          label: 'Máximo por CPF',
          value: this.combo.trigger_rules.maximum_per_client,
          format: 'text',
        },
      ]
    },
    voucherItems() {
      return [
        {
          label: 'Tipo do Voucher',
          value: this.combo.benefits.type,
          format: 'text',
        },
        {
          label: 'Valor do Voucher',
          value: this.combo.benefits.value,
          format: 'currency',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.combo-label {
  font-size: 14px;
  font-weight: 400;
  color: $cinza-0;
}

.combo-name {
  font-size: 14px;
  font-weight: 700;
  color: $cinza-d10;
}

.trigger-target-label {
  font-size: 14px;
  font-weight: 700;
  line-height: 16.8px;
  color: $marca-0-l10;
}

.voucher-container {
  background-color: $cinza-l90;
  padding: 8px 8px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid $cinza-l80;
}
</style>
